import { useState, useEffect } from 'react'

const usePersistedState = (key, value) => {
  let item
  try {
    item = JSON.parse(localStorage.getItem(key)) || value
  } catch (e) {
    item = value
  }

  const [state, setState] = useState(item)
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state))
  }, [key, state])
  return [state, setState]
}

export default usePersistedState
